<template>
  <div class="declaration-scope">
    <div style="display: flex;">
      <div class="show-right section" style="width: 60%;background-color: #FFFFFF;">
        <div class="main-content left" style="margin-left: 20px;margin-bottom: 50px;">
          <el-form :inline="true" :disabled="useHqSet" label-width="130px" label-position="left">
            <div class="el-form-item-wrapper" style="margin-top: 10px;">
              <el-form-item>
                <span class="title" style="font-size: 15px;font-weight: bold;">{{ $t('CargoMsg.Cargo_RPAService') }}</span>
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item>
                <el-checkbox v-model="form.rpaEnabled" no="rpaEnabled" :disabled="!isEdit" @change="rpaEnableChange" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_EnableRPAService') }}</span>
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item>
                <span style="font-size: 13px;" v-html="$t('CargoMsg.Cargo_RPASubmission', [rpaLink])" />
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item>
                <el-input
                  v-model="form.rpaAccount"
                  :disabled="!(isEdit && form.rpaEnabled)"
                  :placeholder="$t('CargoMsg.Cargo_ShippingExchangeAccount')"
                  style="width:300px;"
                />
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item>
                <el-input
                  ref="rpaPassword"
                  v-model="form.rpaPassword"
                  :disabled="!(isEdit && form.rpaEnabled)"
                  :type="inputType"
                  :show-password="isEdit && form.rpaEnabled"
                  :placeholder="$t('CargoMsg.Cargo_ShippingExchangePassword')"
                  style="width:300px;"
                  @click-show-password="toggleShowPassword"
                />
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import lodash from 'lodash'
import { getRpaSettingByAviationExchangePrice
} from '@/api/sysManage/aviationExchangePrice'

export default {
  name: 'TabRpaSettings',
  components: {
    AutoNumberInput,
    CargoAdvanceSelect
  },
  props: {
    isEdit: { type: Boolean, default: false, required: true },
    useHqSet: { type: Boolean, default: false, required: true },
    branchId: { type: Number, default: 0, required: true }
  },
  data() {
    return {
      SystemConstants,
      loading: false,
      isZh: this.$store.getters.language === 'zh',
      selectTypeNames: TYPE_NAMES,
      form: {},
      showPassword: false,
      rpaLink: '<a href="https://filing.chineseshipping.com.cn" target="_blank" style="color:#46a6ff">https://filing.chineseshipping.com.cn/</a>'
    }
  },
  computed: {
    inputType() {
      // 不可编辑时始终为 password
      return !(this.isEdit && this.form.rpaEnabled) ? 'password' : (this.showPassword ? 'text' : 'password')
    }
  },
  watch: {
    'form.rpaEnabled'(val, oldVal) {
      if (!(this.isEdit && val)) {
        this.showPassword = false
      }
      // 变为可编辑时，也强制密文
      if (this.isEdit && val && (!oldVal || !this.isEdit)) {
        this.showPassword = false
      }
    },
    isEdit(val, oldVal) {
      if (!(val && this.form.rpaEnabled)) {
        this.showPassword = false
      }
      // 变为可编辑时，也强制密文
      if (val && this.form.rpaEnabled && (!oldVal || !this.form.rpaEnabled)) {
        this.showPassword = false
      }
    }
  },
  async created() {},
  methods: {
    initForm() {
      this.form = {
        aviationExchangePriceUuid: '',
        rpaEnabled: false,
        rpaAccount: '',
        rpaPassword: ''
      }
    },
    toggleShowPassword() {
      if (this.isEdit && this.form.rpaEnabled) {
        this.showPassword = !this.showPassword
      }
    },
    async onShow(data, isRefresh) {
      if (isRefresh) {
        if (!data || !data.uuid) {
          this.initForm()
          return
        }
        const filter = {
          aviationExchangePriceUuid: data.uuid
        }
        await this.toQuery(filter)
      }
    },
    async toQuery(filter) {
      await getRpaSettingByAviationExchangePrice(filter).then(res => {
        if (res.data) {
          this.form = res.data
        } else {
          this.initForm()
        }
      })
    },
    rpaEnableChange() {
      if (!this.form.rpaEnabled) {
        this.form.rpaAccount = ''
        this.form.rpaPassword = ''
      }
    },
    getSubmitData() {
      const data = lodash.cloneDeep(this.form)
      return {
        aviationExchangePriceRpaSetting: data
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.declaration-scope{
  .title{
    display: inline-block;
    position: relative;
    font-size: 18px;
    padding-left: 15px;
    margin-bottom: 10px;
  }
  .title:before {
    content: '';
    position: absolute;
    width: 4px;
    top: 0;
    left: 0;
    bottom: 0;
    background-color: #1F75D5;
  }
  .el-form-item-wrapper .form-item{
    width: 130px;
  }
  .el-form-item-wrapper .label-span{
    margin-left: 10px;
  }
  /deep/ .el-input-number__increase,
  /deep/ .el-input-number__decrease {
    width: 15px !important; /* 你可以根据需要调整宽度 */
    min-width: 15px !important;
    padding: 0;
  }
}
</style>
